<template>
    <div>
        <v-container>
           <p class="text-center display-1 my-3 gray--text">
                Pipe Me In - Setup
            </p>
            <v-layout row justify-center class="mt-5 hidden-sm-and-down">
                
                <v-flex xs12 md3>
                    <v-img src="@/assets/Colm.jpg"
                    style="border-top-left-radius:40px;border-bottom-left-radius:40px;"
                    ></v-img>
                </v-flex>
                <v-flex xs12 md7>
                    <v-card flat style="border-radius: 0%;">
                        <v-card-text class="title orange white--text" 
                        style="width:80%;padding-left:230px;">
                            Features
                        </v-card-text>
                        <v-card-text class="title"> 
                            1° Reusable: Yes. <br>
                            2° Flexible: Yes. <br>
                            3° 25% lighter than regular outdoor PVC. <br>
                            4° Compatible with other 3" PVC parts in the market.
                        </v-card-text>
                        <v-card-text>
                            <v-img src="@/assets/com.png" 
                            width="300"
                            ></v-img>
                            <v-img width="79" height="61" style="margin-left:490px;margin-top:-90px"
                            src="https://pipemein.com/files/pipemein/image/usa.png" 
                            ></v-img>
                        </v-card-text>
                    </v-card>
                </v-flex>

            </v-layout>

            <v-layout row justify-center class="mt-5 hidden-md-and-up">
                
                <v-flex xs12 md3>
                    <v-img src="@/assets/Colm.jpg" height="300"
                    ></v-img>
                </v-flex>
                <v-flex xs12 md7>
                    <v-card flat style="border-radius: 0%;">
                        <v-card-text class="title text-center orange white--text" 
                        >
                            Features
                        </v-card-text>
                        <v-card-text class="title"> 
                            1° Reusable: Yes. <br>
                            2° Flexible: Yes. <br>
                            3° 25% lighter than regular outdoor PVC. <br>
                            4° Compatible with other 3" PVC parts in the market.
                        </v-card-text>
                        <v-card-text>
                            <v-img src="@/assets/com.png" 
                            width="300"
                            style="margin:0 auto;display:block"
                            ></v-img>
                            <v-img width="79" height="61" src="https://pipemein.com/files/pipemein/image/usa.png"
                        style="margin-left:45px;margin-top:20px;"></v-img>
                        </v-card-text>
                    </v-card>
                </v-flex>

            </v-layout>
        </v-container>
    </div>
</template>


<style>
    
</style>

<script>
export default {
    
    data() {
        return {
            

        }
    },

}
</script>